// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-registry-modal .modal-dialog {
  max-width: 900px;
  width: calc(100% - 32px);
}

.private-registry-modal .modal-body .form-control {
  word-break: break-all;
}

.private-registry-modal .member-row .btn {
  height: 38px;
  width: 38px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.private-registry-modal .member-row {
  align-items: center;
}

.private-registry-modal .member-row .btn i {
  margin: 0;
}

@media (min-width: 1200px) {
  .private-registry-modal .modal-dialog {
    max-width: 1100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivateRegistryModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".private-registry-modal .modal-dialog {\n  max-width: 900px;\n  width: calc(100% - 32px);\n}\n\n.private-registry-modal .modal-body .form-control {\n  word-break: break-all;\n}\n\n.private-registry-modal .member-row .btn {\n  height: 38px;\n  width: 38px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.private-registry-modal .member-row {\n  align-items: center;\n}\n\n.private-registry-modal .member-row .btn i {\n  margin: 0;\n}\n\n@media (min-width: 1200px) {\n  .private-registry-modal .modal-dialog {\n    max-width: 1100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
